/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum PosSessionStatus {
  Open = 'OPEN',
  Closed = 'CLOSED'
}
